 document.addEventListener('DOMContentLoaded', function () {
      const faqItems = document.querySelectorAll('.faq-item');

      faqItems.forEach((item) => {
        const button = item.querySelector('.faq-question');
        button.addEventListener('click', () => {
          // Close all other FAQs
          faqItems.forEach((i) => {
            if (i !== item) i.classList.remove('active');
          });
          // Toggle clicked one
          item.classList.toggle('active');
        });
      });
    });